import React from "react";

// Pixel-grid overlay: 10px dot grid + 100px major lines.
// z:100 — above content/boxes, below alignment guides (9998).
export const SnapContainer = () => (
  <svg
    width="100%"
    height="100%"
    style={{
      position: "absolute",
      inset: 0,
      zIndex: 100,
      pointerEvents: "none",
    }}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <pattern id="grid-minor" width="10" height="10" patternUnits="userSpaceOnUse">
        <circle cx="0.5" cy="0.5" r="0.75" fill="rgba(100, 116, 139, 0.35)" />
      </pattern>
      <pattern id="grid-major" width="100" height="100" patternUnits="userSpaceOnUse">
        <rect width="100" height="100" fill="url(#grid-minor)" />
        <path
          d="M 100 0 L 0 0 0 100"
          fill="none"
          stroke="rgba(100, 116, 139, 0.45)"
          strokeWidth="0.5"
        />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#grid-major)" />
  </svg>
);
